import { createBooking, getBookingDetails, saveBookingToDatabase, saveGuestDetailsToDatabase, updateBookingInDatabase, getGuestDetailsFromDatabase, updateGuestDetails, updateBookingStatus, sendDepositConfirmationEmail, sendConfirmBookingEmail } from "../../../frontend/src/api-client";
import { BookingResponse, PassengerDetails } from "../../../backend/src/models/bookingDetails";

export const processBooking = async (
  destinationId: string,
  responseTokenId: string,
  //primaryGuest: string,
  selectedRoom: any,
  selectedDeal: any,
  passengers: any[],
  user: any,
  leadPassengerEmail: string,
  amount: number,
  selectedPlan: string,
  selectedPrice: any,
  totalCount: any
) => {
  try {
    // Create booking
    const bookingResponse = await createBooking(destinationId, responseTokenId, {
      primaryGuestName:  passengers[0].firstName +" "+ passengers[0].lastName,
      groups: [
        {
          id: "group-1",
          room: selectedRoom?.code ?? '',
          deal: selectedDeal?.id ?? '',
        },
      ],
    }, "");

    // Fetch booking details
    const bookingDetails = await getBookingDetails(bookingResponse.responseToken);

    if (user) {
      await saveBookingToDatabase(bookingDetails, user.userId, 'paid', new Date().toISOString(), leadPassengerEmail);
      await saveGuestDetailsToDatabase(user.userId, passengers, bookingResponse.responseToken);
      const guestDetailsFromDB = await getGuestDetailsFromDatabase(user.userId, bookingResponse.responseToken);

      const data: BookingResponse = await getBookingDetails(bookingResponse.responseToken);

      const extractedGuests: PassengerDetails[] = data.paxGroups.flatMap((group) =>
        group.guestDetails.map((guest, guestIndex) => {
          const matchingGuest = guestDetailsFromDB[0]?.passengers?.[guestIndex] || {};
          return {
            id: guest.id,
            primary: guest.primary,
            type: guest.type,
            wheelChair: matchingGuest.wheelChair ?? false,
            firstName: matchingGuest.firstName ?? "",
            lastName: matchingGuest.lastName ?? "",
            childAge: guest.type === "child" ? guest.age : undefined,
            arrivalFlightDate: "",
            arrivalFlightAirline: guest.flightDetails.find(f => f.type === "arrival")?.flightNo || "",
            arrivalFlightNumber: guest.flightDetails.find(f => f.type === "arrival")?.flightNo || "",
            departureFlightDate: "",
            departureFlightAirline: guest.flightDetails.find(f => f.type === "departure")?.flightNo || "",
            departureFlightNumber: guest.flightDetails.find(f => f.type === "departure")?.flightNo || "",
          };
        })
      );

      await updateGuestDetails(bookingResponse.responseToken, extractedGuests);
      await updateBookingInDatabase(bookingDetails, user.userId, new Date().toISOString());

      const updatedStatus = bookingDetails.bookingStatus === 'pending' ? 'paid-error' : 'paid';
      await updateBookingStatus(updatedStatus, bookingDetails.reference, amount.toString());

      if (selectedPlan === 'Easy Payment Plan') {
        const totalDeposit = selectedPrice * totalCount;
        await sendDepositConfirmationEmail(passengers[0].email, bookingDetails, updatedStatus, totalDeposit.toString());
      } else if (selectedPlan != 'Free Fare Hold') {
        await sendConfirmBookingEmail(passengers[0].email, bookingDetails, updatedStatus);
      }
    } else {
      await saveBookingToDatabase(bookingDetails, '', 'paid', new Date().toISOString(), leadPassengerEmail);
      await saveGuestDetailsToDatabase('', passengers, bookingResponse.responseToken);

      const updatedStatus = bookingDetails.bookingStatus === 'pending' ? 'paid-error' : 'paid';
      await updateBookingStatus(updatedStatus, bookingDetails.reference, amount.toString());
    }

    return { bookingDetails, bookingResponse };
  } catch (error) {
    console.error("Failed to process booking:", error);
    throw error;
  }
};
